const Card = {
  baseStyle: {
    container: {
      
    },
    header: {
      borderColor: 'rgba(0, 0, 0, 0.10)',
      borderBottomWidth: '1px',
    },
    body: {
      
    },
    footer: {
      
    },
  },
  variants: {
    stat: {
      container: {
        border: 'none',
        borderRadius: '16px',
        boxShadow: '0px 3px 8.8px 1px rgba(228, 229, 231, 0.15)'
      },
      header: {
        border: 'none'
      }
    }
  },
  sizes: {
    md: {
      header: {
        px: '30px',
        py: '20px',
        mb: '20px'
      },
      body: {
        p: '30px',
        pt: 0
      }
    },
    sm: {
      header: {
        px: '20px',
        py: '20px',
        mb: '15px'
      },
      body: {
        p: '20px',
        pt: 0
      }
    }
  },
  defaultProps: {
    
  }
};

export default Card;
